import { storage } from '../../utils/tools'
import { EventEmitter } from '../../EventEmitter'
import { uploadPagesCloud, getPagesCloud, delPagesCloud, editPagesCloud } from "../apis/technology";
import {getType} from '../apis/project'
let _components = [] //组件库
/**
 * 组件操作
 * @class Components
 */
export class Components extends EventEmitter {
    constructor(technology) {
        super()
        this.technology = technology;
        
        this.device = this.technology.data.device
        storage.getItem('topo_components')
            .then((val) => {
                this.emit('components.ready', val)
                this.componentsReady = true;
                _components = val || []
            })
    }
    // 组件库加载状态
    componentsReady = false;
    /**
 * 获取组件库
 */
    get components() {
        return _components;
    }

    /**
     * 上传组件到云端
     */
    uploadCloud() {

    }
    /**
     * 上传拓扑数据到云端
     * @param {object} data 
     * @returns 
     */
    async uploadPagesCloud(data) {
        if (!this.technology.data.device || !this.technology.data.device) {
            return Promise.reject('请先选择设备类型')
        }
        return uploadPagesCloud(this.technology.data.device.typeId, data)
    }
    /**
     * 获取所有的拓扑数据
     * @returns {Promise<any>}
     */
    async getPagesCloud() {
        if (!this.technology.data.device || !this.technology.data.device) {
            return Promise.reject('请先选择设备类型')
        }
        return getPagesCloud(this.technology.data.device.typeId)
    }
    /**
     * 编辑拓扑数据
     * @param {number} id 
     * @param {object} data 
     * @returns {Promise<any>}
     */
    async editPagesCloud(id, data) {
        if (!this.technology.data.device || !this.technology.data.device) {
            return Promise.reject('请先选择设备类型')
        }
        return editPagesCloud(this.technology.data.device.typeId, id, data)
    }
    /**
        * 删除拓扑数据
        * @param {number} id 
        * @returns {Promise<any>}
        */
    async delPagesCloud(id) {
        if (!this.technology.data.device || !this.technology.data.device) {
            return Promise.reject('请先选择设备类型')
        }
        return delPagesCloud(this.technology.data.device.typeId, id)
    }

    set components(val) {
        let index = _components.findIndex((item) => item.id === val.id)
        if (index > -1) {
            _components.splice(index, 1, val);
        } else {
            _components.push(val);
        }

 
        storage.setItem('topo_components',JSON.parse(JSON.stringify(_components)))
        this.technology.proc.data._components = _components;
    }

    removeComponent(id) {
        for (let i = 0; i < _components.length; i++) {
            if (_components[i].id === id) {
                _components.splice(i, 1);
            }
        }
        storage.setItem('topo_components', _components)
        this.technology.proc.data._components = _components;
    }

    /**
     * 删除组件
     * @param {string} id 组件id
     */
    remove(id) {
        for (let i = 0; i < _components.length; i++) {
            if (_components[i].id === id) {
                _components.splice(i, 1);
            }
        }
        storage.setItem('topo_components', _components)
    }

    /**
     * 获取设备类型信息
     * @param {number} typeid 
     * @returns 
     */
    getType(typeid){
        return getType(typeid)
    }
}